// removed by extract-text-webpack-plugin
module.exports = {"textLink":"bmiV0"};